import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Clock, Users } from 'lucide-react';

const TrustBar = () => {
  const trustStatements = [
    {
      icon: Shield,
      text: 'Trusted by property managers, facilities teams & operations directors',
    },
    {
      icon: Clock,
      text: 'Rapid deployment capability across London and the UK',
    },
    {
      icon: Users,
      text: 'Structured workforce with documented accountability systems',
    },
  ];

  return (
    <section className="bg-primary-light py-8 md:py-10 relative overflow-hidden" data-testid="trust-bar">
      {/* Animated background decoration */}
      <motion.div 
        className="absolute inset-0 opacity-30"
        animate={{ 
          background: [
            'radial-gradient(circle at 20% 50%, rgba(0, 68, 201, 0.1) 0%, transparent 50%)',
            'radial-gradient(circle at 80% 50%, rgba(255, 94, 0, 0.1) 0%, transparent 50%)',
            'radial-gradient(circle at 20% 50%, rgba(0, 68, 201, 0.1) 0%, transparent 50%)',
          ]
        }}
        transition={{ duration: 8, repeat: Infinity, ease: 'easeInOut' }}
      />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {trustStatements.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
              whileHover={{ scale: 1.02, y: -2 }}
              className="flex items-center justify-center gap-4 text-center md:text-left p-4 rounded-sm hover:bg-white/50 transition-all duration-300"
              data-testid={`trust-statement-${index}`}
            >
              <motion.div
                whileHover={{ rotate: 10, scale: 1.1 }}
                transition={{ type: 'spring', stiffness: 300 }}
              >
                <item.icon className="w-7 h-7 text-accent flex-shrink-0" />
              </motion.div>
              <span className="font-manrope text-sm md:text-base text-slate-700 font-medium">
                {item.text}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
